<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Icon } from '@iconify/vue'
import ProfessorMark from '@/components/ProfessorMark.vue'
const route=useRoute();const router=useRouter();const hidden=computed(()=>route.path==='/tutor')
</script>
<template><button v-if="!hidden" class="assistant-dock" aria-label="向奥博士提问" @click="router.push('/tutor')"><ProfessorMark variant="dock"/><span><small>ACADEMIC ASSISTANT</small><strong>奥博士 · 可随时追问</strong></span><Icon icon="solar:arrow-right-up-linear" width="19"/></button></template>
